/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Bin
 * 
 * 1 = Shelf
 * 
 * 2 = Rack
 * 
 * 3 = Zone
 * 
 * 4 = Warehouse
 */
export enum PartLocationType {
  Bin = 0,
  Shelf = 1,
  Rack = 2,
  Zone = 3,
  Warehouse = 4
}
